// @mui
import { ListItemText, ListItemAvatar, ListItem } from "@mui/material";
import Iconify from "../iconify";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import React, { useEffect, useState } from "react";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import axios from "axios";
import moment from "moment";
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
  IconButton,
  Alert,
  OutlinedInput,
  Chip,
} from "@mui/material";
// ----------------------------------------------------------------------
const dateFormat = "YYYY-MM-DD HH:mm:ss";

export default function EditPrizeSettings(props) {
  const addPrizeLevelHandler = () => {
    props.state.prizesBreakdown.push({
      placeStart: props.state.prizesBreakdown.length + 1,
      placeEnd: props.state.prizesBreakdown.length + 1,
      prizeText: "",
      prizeValue: 100,
    });
    props.handleChangePrizesBreakdown([...props.state.prizesBreakdown]);
  };
  const removePrizeLevelHandler = (index) => {
    props.state.prizesBreakdown.splice(index, 1);
    props.handleChangePrizesBreakdown([...props.state.prizesBreakdown]);
  };

  const handleChangePrize = (value, index, name) => {
    props.state.prizesBreakdown[index][name] = value;
    props.handleChangePrizesBreakdown([...props.state.prizesBreakdown]);
  };

  return (
    <Card sx={{ padding: 4 }}>
      {props.loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center" }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {props.state.prizesBreakdown.map((prize, index) => (
            <Grid item xs={12} key={`prize-${index}`}>
              <Grid container spacing={3}>
                <Grid item xs={1}>
                  <TextField
                    id="placeStart"
                    label="Start Place"
                    fullWidth
                    value={props.state.prizesBreakdown[index].placeStart}
                    variant="standard"
                    onChange={(e) =>
                      handleChangePrize(e.target.value, index, "placeStart")
                    }
                  />
                </Grid>
                <Grid item xs={1}>
                  <TextField
                    id="placeEnd"
                    label="End Place"
                    fullWidth
                    value={props.state.prizesBreakdown[index].placeEnd}
                    variant="standard"
                    onChange={(e) =>
                      handleChangePrize(e.target.value, index, "placeEnd")
                    }
                  />
                </Grid>
                <Grid item xs={1} sx={{ pt: 4 }}></Grid>
                <Grid item xs={2}>
                  <TextField
                    id="prizeText"
                    label="Prize Text"
                    fullWidth
                    value={props.state.prizesBreakdown[index].prizeText}
                    variant="standard"
                    onChange={(e) =>
                      handleChangePrize(e.target.value, index, "prizeText")
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    id="prizeValue"
                    label="Cash Prize Value"
                    fullWidth
                    value={props.state.prizesBreakdown[index].prizeValue}
                    variant="standard"
                    onChange={(e) =>
                      handleChangePrize(e.target.value, index, "prizeValue")
                    }
                  />
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                    onClick={() => removePrizeLevelHandler(index)}
                  >
                    <Iconify icon={"eva:trash-2-outline"} />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          ))}
          <Grid item xs={12}>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:plus-circle-outline" />}
              onClick={() => addPrizeLevelHandler()}
              sx={{ mr: 2 }}
            >
              Add Prize Level
            </Button>
          </Grid>
        </Grid>
      )}
    </Card>
  );
}
